import { request } from './index';
const mixpanel = {
  actions: {
    async mpTrack(_, payload) {
      const data = await request('/user/mixpanel/track', 'POST', payload);
      return data;
    }
  }
};
export default mixpanel;